<template>
	<v-card outlined style="height: 100%">
		<TiptapVuetify
			:card-props="{ flat: true, color: 'white' }"
			:extensions="$options.editorExtensions"
			:toolbar-attributes="{ color: 'info' }"
			@input="$emit('show-change')"
			v-model="_value"
		/>
	</v-card>
</template>

<script>
import {
	TiptapVuetify,
	Heading,
	Bold,
	Italic,
	Strike,
	Underline,
	Code,
	Paragraph,
	BulletList,
	OrderedList,
	ListItem,
	Link,
	Blockquote,
	HardBreak,
	HorizontalRule,
	History,
	Image,
	Table,
	TableHeader,
	TableCell,
	TableRow
} from 'tiptap-vuetify'

import ImageUploadResizer from './ImageUploadResizer'

export default {
	name: 'TextEditor',

	props: ['value'],

	components: {
		TiptapVuetify
	},

	computed: {
		_value: {
			get() {
				return this.value
			},
			set(value) {
				this.$emit('input', value)
			}
		}
	},

	editorExtensions: [
		History,
		Blockquote,
		Link,
		Underline,
		Strike,
		Italic,
		ListItem,
		BulletList,
		OrderedList,
		[
			Heading,
			{
				options: {
					levels: [1, 2, 3]
				}
			}
		],
		Bold,
		Code,
		HorizontalRule,
		Paragraph,
		HardBreak,
		[Image, {
			options: {
				imageSources: [
					{ component: ImageUploadResizer, name: 'S3 Image Upload'}
				],
				imageSourcesOverride: true
			}
		}],
		Table,
		TableHeader,
		TableCell,
		TableRow
	]
}
</script>

<style lang="scss" >
.tiptap-vuetify-editor__content, .ProseMirror {
	height: 100% !important;
}

.ProseMirror {
	min-height: 200px
}
</style>
